import { Language } from "../constants/language";
import { Alert } from "./alert";
import { PassEncryption } from "./encryption";

export class Member {
	number: number;
	erid: string;
	ssnDecrypted: string;
	name: string;
	gender: string;
	enrollmentUID: string;
	dobDecrypted: string;
	homeAddressLine1: string;
	homeAddressLine2: string;
	homeCity: string;
	homeState: string;
	homeZipCode: string;
	homeEmail: string;
	homePhone: string;
	cellPhone: string;
	dateOfHire: string;
	workJobTitle: string;
	workHours: number;
	companyLocation: string;
	companyLocationCaption: string;
	employmentStatus: string;
	employmentStatusCaption: string;
	department: string;
	departmentCaption: string;
	position: string;
	positionCaption: string;
	firstName: string;
	lastName: string;

	displayEEClass1: string;
	displayEEClass2: string;
	displayEEClass3: string;
	displayEEClass4: string;
	displayEEClass5: string;
	displayDivision: string;

	displayEEClass1Caption: string;
	displayEEClass2Caption: string;
	displayEEClass3Caption: string;
	displayEEClass4Caption: string;
	displayEEClass5Caption: string;
	displayDivisionCaption: string;

	displayUDF1: string;
	displayUDF2: string;
	displayUDF3: string;
	displayUDF4: string;
	displayUDF5: string;

	displayUDF1Caption: string;
	displayUDF2Caption: string;
	displayUDF3Caption: string;
	displayUDF4Caption: string;
	displayUDF5Caption: string;

	enableSaveButton: boolean;

	showNumber: boolean;
	numberReadOnly: boolean;

	showERID: boolean;
	eridReadOnly: boolean;

	showEnrollmentUID: boolean;
	enrollmentUIDReadOnly: boolean;

	showDOBDecrypted: boolean;
	dobDecryptedReadOnly: boolean;

	showHomeEmail: boolean;
	homeEmailReadOnly: boolean;

	showHomePhone: boolean;
	homePhoneReadOnly: boolean;

	showCellPhone: boolean;
	cellPhoneReadOnly: boolean;

	showDateOfHire: boolean;
	dateOfHireReadOnly: boolean;

	showName: boolean;
	nameReadOnly: boolean;

	showWorkJobTitle: boolean;
	workJobTitleReadOnly: boolean;

	showAddress: boolean;
	addressReadOnly: boolean;

	showHomeCity: boolean;
	homeCityReadOnly: boolean;

	showHomeState: boolean;
	homeStateReadOnly: boolean;

	showHomeZipCode: boolean;
	homeZipCodeReadOnly: boolean;

	showGender: boolean;
	genderReadOnly: boolean;

	showWorkHours: boolean;
	workHoursReadOnly: boolean;

	showSSNDecrypted: boolean;
	ssnDecryptedReadOnly: boolean;

	showCompanyLocation: boolean;
	companyLocationReadOnly: boolean;

	showEmploymentStatus: boolean;
	employmentStatusReadOnly: boolean;

	showDepartment: boolean;
	departmentReadOnly: boolean;

	showPosition: boolean;
	positionReadOnly: boolean;

	showDivision: boolean;
	divisionReadOnly: boolean;

	showEEClass1: boolean;
	eeClass1ReadOnly: boolean;

	showEEClass2: boolean;
	eeClass2ReadOnly: boolean;

	showEEClass3: boolean;
	eeClass3ReadOnly: boolean;

	showEEClass4: boolean;
	eeClass4ReadOnly: boolean;

	showEEClass5: boolean;
	eeClass5ReadOnly: boolean;

	showUdf1: boolean;
	udf1ReadOnly: boolean;

	showUdf2: boolean;
	udf2ReadOnly: boolean;

	showUdf3: boolean;
	udf3ReadOnly: boolean;

	showUdf4: boolean;
	udf4ReadOnly: boolean;

	showUdf5: boolean;
	udf5ReadOnly: boolean;

	constructor() {
		this.number = 0;
		this.erid = null;
		this.ssnDecrypted = null;
		this.enrollmentUID = null;
		this.dobDecrypted = null;
		this.gender = null;
		this.homeAddressLine1 = null;
		this.homeAddressLine2 = null;
		this.homeCity = null;
		this.homeState = null;
		this.homeZipCode = null;
		this.homeEmail = null;
		this.homePhone = null;
		this.cellPhone = null;
		this.dateOfHire = null;
		this.name = null;
		this.workJobTitle = null;
		this.workHours = 0;
		this.companyLocation = null;
		this.companyLocationCaption = null;
		this.employmentStatus = null;
		this.employmentStatusCaption = null;
		this.department = null;
		this.departmentCaption = null;
		this.position = null;
		this.firstName = null;
		this.lastName = null;
		this.positionCaption = null;
		this.displayEEClass1 = null;
		this.displayEEClass2 = null;
		this.displayEEClass3 = null;
		this.displayEEClass4 = null;
		this.displayEEClass5 = null;
		this.displayDivision = null;
		this.displayEEClass1Caption = null;
		this.displayEEClass2Caption = null;
		this.displayEEClass3Caption = null;
		this.displayEEClass4Caption = null;
		this.displayEEClass5Caption = null;
		this.displayDivisionCaption = null;
		this.displayUDF1Caption = null;
		this.displayUDF2Caption = null;
		this.displayUDF3Caption = null;
		this.displayUDF4Caption = null;
		this.displayUDF5Caption = null;
		this.showDivision = false;
		this.divisionReadOnly = false;
		this.showEEClass1 = false;
		this.eeClass1ReadOnly = false;
		this.showEEClass2 = false;
		this.eeClass2ReadOnly = false;
		this.showEEClass3 = false;
		this.eeClass3ReadOnly = false;
		this.showEEClass4 = false;
		this.eeClass4ReadOnly = false;
		this.showEEClass5 = false;
		this.eeClass5ReadOnly = false;
		this.showCompanyLocation = false;
		this.showEmploymentStatus = false;
		this.showDepartment = false;
		this.showPosition = false;
		this.enableSaveButton = false;
		this.showNumber = false;
		this.numberReadOnly = false;
		this.showERID = false;
		this.eridReadOnly = false;
		this.showEnrollmentUID = false;
		this.enrollmentUIDReadOnly = false;
		this.showDOBDecrypted = false;
		this.dobDecryptedReadOnly = false;
		this.showHomeEmail = false;
		this.homeEmailReadOnly = false;
		this.showHomePhone = false;
		this.homePhoneReadOnly = false;
		this.showCellPhone = false;
		this.cellPhoneReadOnly = false;
		this.showDateOfHire = false;
		this.dateOfHireReadOnly = false;
		this.showName = false;
		this.nameReadOnly = false;
		this.showWorkJobTitle = false;
		this.workJobTitleReadOnly = false;
		this.showAddress = false;
		this.addressReadOnly = false;
		this.showHomeCity = false;
		this.homeCityReadOnly = false;
		this.showHomeState = false;
		this.homeStateReadOnly = false;
		this.showHomeZipCode = false;
		this.homeZipCodeReadOnly = false;
		this.showGender = false;
		this.genderReadOnly = false;
		this.showWorkHours = false;
		this.workHoursReadOnly = false;
		this.showSSNDecrypted = false;
		this.ssnDecryptedReadOnly = false;
		this.showCompanyLocation = false;
		this.companyLocationReadOnly = false;
		this.showEmploymentStatus = false;
		this.employmentStatusReadOnly = false;
		this.showDepartment = false;
		this.departmentReadOnly = false;
		this.showPosition = false;
		this.positionReadOnly = false;
		this.showUdf1 = false;
		this.udf1ReadOnly = false;
		this.showUdf2 = false;
		this.udf2ReadOnly = false;
		this.showUdf3 = false;
		this.udf3ReadOnly = false;
		this.showUdf4 = false;
		this.udf4ReadOnly = false;
		this.showUdf5 = false;
		this.udf5ReadOnly = false;
	}
}

export class UpdateMemberProfile {
	erid: string;
	ssnDecrypted: string;
	name: string;
	gender: string;
	enrollmentUID: string;
	dobDecrypted: string;
	homeAddressLine1: string;
	homeAddressLine2: string;
	homeCity: string;
	homeState: string;
	homeZipCode: string;
	homeEmail: string;
	homePhone: string;
	cellPhone: string;
	dateOfHire: string;
	workJobTitle: string;
	workHours: number;
	companyLocation: string;
	employmentStatus: string;
	department: string;
	position: string;
	displayEEClass1: string;
	displayEEClass2: string;
	displayEEClass3: string;
	displayEEClass4: string;
	displayEEClass5: string;
	displayDivision: string;
	displayUDF1: string;
	displayUDF2: string;
	displayUDF3: string;
	displayUDF4: string;
	displayUDF5: string;

	constructor() {
		this.erid = null;
		this.ssnDecrypted = null;
		this.enrollmentUID = null;
		this.dobDecrypted = null;
		this.gender = null;
		this.homeAddressLine1 = null;
		this.homeAddressLine2 = null;
		this.homeCity = null;
		this.homeState = null;
		this.homeZipCode = null;
		this.homeEmail = null;
		this.homePhone = null;
		this.cellPhone = null;
		this.dateOfHire = null;
		this.name = null;
		this.workJobTitle = null;
		this.workHours = 0;
		this.companyLocation = null;
		this.employmentStatus = null;
		this.department = null;
		this.position = null;
		this.displayEEClass1 = null;
		this.displayEEClass2 = null;
		this.displayEEClass3 = null;
		this.displayEEClass4 = null;
		this.displayEEClass5 = null;
		this.displayDivision = null;
		this.displayUDF1 = null;
		this.displayUDF2 = null;
		this.displayUDF3 = null;
		this.displayUDF4 = null;
		this.displayUDF5 = null;
	}
}

export class MemberLogin {
	username: string;
	password: string;
	systemNumber: string | number;
	adminDirectSystem: string;
	agentCity: string;
	agentState: string;
	otp: string;
	callerID: string;
	adminUserID: string;
	isPortal: boolean;

	constructor() {
		this.username = null;
		this.password = null;
		this.systemNumber = null;
		this.adminDirectSystem = null;
		this.agentCity = null;
		this.agentState = null;
		this.otp = null;
		this.callerID = null;
		this.adminUserID = null;
		this.isPortal = true;
	}
}

export class BaseMemberSession {
	companyName: string;
	isVerified: boolean;
	systemNumber: number;
	memberName: string;
	accessToken: string;
	refreshToken: string;
	memberSSNNoRequired: boolean;
	mustResetPassword: boolean;
	companyCode: string;
	adminUserID: number;
	adminUserName: string;
	phoneNumber: number;
	id: number;
	divisionName: string;
	validationMessage: string;
	locationName: string;
	firstName: string;
	pyidMatchedMember: boolean;

	constructor() {
		this.companyName = null;
		this.isVerified = false;
		this.systemNumber = 0;
		this.memberName = null;
		this.accessToken = null;
		this.refreshToken = null;
		this.memberSSNNoRequired = false;
		this.mustResetPassword = false;
		this.companyCode = null;
		this.adminUserID = 0;
		this.adminUserName = '';
		this.phoneNumber = 0;
		this.id = 0;
		this.divisionName = '';
		this.validationMessage = '';
		this.locationName = '';
		this.firstName = null;
		this.pyidMatchedMember = false;
	}
}

export class StartSelectedMemberSession {
	accessToken: string;
	refreshToken: string;
	session: MemberSession;
	pyidMatchedMember: boolean;

	constructor() {
		this.accessToken = null;
		this.refreshToken = null;
		this.session = new MemberSession();
		this.pyidMatchedMember = false;

	}
}


// MemberSession && MemberSessionLoginResponse
export class MemberSession extends BaseMemberSession {
	isEnrollmentAvailableForMember: boolean;
	companyImagePath: string;
	dashboardTemplate: string;
	showDependentVerification: boolean;
	showLifeEventVerification: boolean;
	showMemberAccounting: boolean;
	requireDependentVerificationDocuments: boolean;
	isVbo: boolean;
	dontRequireSpouseSSN: boolean;
	hasSSN: boolean;
	showMemberWaiveDocuments: boolean;
	showWaiveDocuments: boolean;
	enrollmentCategoryModelVBO: boolean;
	isOpenEnrollmentActive: boolean;
	operatingMode: string;
	isUSAePayEnabled: boolean;
	isEnrollmentReady?: boolean;
	useACAModule: boolean;
	usePayrollModule: boolean;
	useYearRound: boolean;
	languagePreference: Language;
	availablePTO: string;
	availableSickTime: string;
	messageCenterAlerts: Alert[];
	divisionCaption: string;
	division: string;
	email: string;
	firstName: string;
	cellPhone: string;
	isCellPhoneMFAConfigured: boolean;

	constructor() {
		super();
		this.isEnrollmentAvailableForMember = false;
		this.companyImagePath = null;
		this.dashboardTemplate = null;
		this.showDependentVerification = false;
		this.showLifeEventVerification = false;
		this.showMemberAccounting = false;
		this.requireDependentVerificationDocuments = false;
		this.isVbo = false;
		this.dontRequireSpouseSSN = false;
		this.hasSSN = false;
		this.showMemberWaiveDocuments = false;
		this.showWaiveDocuments = false;
		this.enrollmentCategoryModelVBO = false;
		this.isOpenEnrollmentActive = false;
		this.operatingMode = null;
		this.isEnrollmentReady = null;
		this.isUSAePayEnabled = false;
		this.useACAModule = false;
		this.usePayrollModule = false;
		this.useYearRound = false;
		this.languagePreference = Language.en;
		this.availablePTO = null;
		this.availableSickTime = null;
		this.messageCenterAlerts = null;
		this.divisionCaption = null;
		this.division = null;
		this.email = null;
		this.firstName = null;
		this.cellPhone = null;
		this.isCellPhoneMFAConfigured = false;
	}
}

export class LoginPayload extends MemberLogin {
	buildNumber: string;
	operatingSystem: string;
	comCode: string;
	reCaptchaID?: number;
	reCaptchaToken?: string;
	languagePreference: string;
	passEncryption: PassEncryption;
	pyid: string;
	memberid: string;

	constructor() {
		super();
		this.buildNumber = null;
		this.operatingSystem = null;
		this.comCode = null;
		this.reCaptchaID = null;
		this.reCaptchaToken = null;
		this.languagePreference = null;
		this.passEncryption = new PassEncryption()
		this.pyid = null;
		this.memberid = null;
	}
}

export class MemberAuthorizationResult {
	authorized: boolean;
	role: string;
	permissions: [];
	username: string;
	members: BaseMemberSession[];
	isMemberAutoLoggedIn: boolean;
	startSessionModel: MemberSession;
	isCodeVerfied: boolean;
	errorMessage: string;

	constructor() {
		this.authorized = null;
		this.role = null;
		this.permissions = [];
		this.username = null;
		this.members = [];
		this.isMemberAutoLoggedIn = false;
		this.startSessionModel = null;
		this.isCodeVerfied = false;
		this.errorMessage = null;
	}
}

export class MultiMemberSelectResult {
	reCaptchaID: number;
	reCaptchaToken: string;
	members: BaseMemberSession[];

	constructor() {
		this.reCaptchaID = null;
		this.reCaptchaToken = null;
		this.members = [];
	}
}
